'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-actions/lib/ownKeys.js
 ** module id = 393
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-actions/lib/ownKeys.js
 ** module id = 393
 ** module chunks = 1
 **/